<template>
  <div>
    <v-dialog scrollable v-model="editDialog" persistent max-width="1200px">
      <material-card
        v-if="editedItem !== null && editedItem !== undefined"
        :title="
          editedIndex > -1
            ? $t(
                'components.plan_builder.self_payment_settings.edit_group_{0}',
                [trans(editedItem.MemberGroup, 'Name')]
              )
            : $t('components.plan_builder.self_payment_settings.add_group')
        "
        icon="edit"
        :color="
          editedIndex > -1
            ? $vuetify.theme.themes.light.primary
            : $vuetify.theme.themes.light.success
        "
      >
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-container fluid grid-list-md>
              <v-row>
                <v-col cols="12" sm="4" align-self-end>
                  <trans-select2
                    v-model="editedItem"
                    propertyName="MemberGroup"
                    :items="memberGroups"
                    :label="
                      $t(
                        'headers.members_management.MemberGroupIdentityTranslations'
                      )
                    "
                    :rules="[$rules.required]"
                    class="required"
                    field="Name"
                    itemValue="Identifier"
                  ></trans-select2>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <self-payment-conditions
          v-if="editedItem.MemberGroup"
            :disabled="disabled"
            :selfPaymentConditions="editedItem.SelfPaymentConditions"
            @update-self-payment-conditions="updateSelfPaymentConditions"
            :coverage="editedItem.MemberGroup.CoverageIdentities"
          ></self-payment-conditions>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="close">{{ $t("globals.cancel") }}</v-btn>
          <v-btn :disabled="!valid" color="primary" @click="save">
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="deleteDialog" persistent max-width="400">
      <material-card
        v-if="editedItem"
        :title="
          $t(
            'components.plan_builder.self_payment_settings.remove_member_group_{0}',
            [trans(editedItem.MemberGroup, 'Name')]
          )
        "
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="deleteDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" text @click="tryDelete">
            {{ $t("globals.remove") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <material-card
      :title="$t('components.plan_builder.self_payment_settings')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="group_work"
    >
      <pbas-data-table
        ref="table"
        :dataProvider="provider"
        :rowActions="rowActions"
        :floatActions="floatActions"
        fileNamePrefix="self_payment_settings"
        identifier="self_payment_settings_table"
        @error="error = $event"
      ></pbas-data-table>
    </material-card>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import { InMemoryProvider } from "pbas-vue-components";
import SelfPaymentSettingsHeaders from "@/headers/SelfPaymentSettings";
import TransTextbox from "@/components/TransTextbox";
import TransTextarea from "@/components/TransTextarea";
import { translate2 } from "@/trans2";
import TransMultiSelect2 from "@/components/TransMultiSelect2";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import TransSelect2 from "../TransSelect2.vue";
import SelfPaymentConditions from "./SelfPaymentConditions";

export default {
  components: {
    ErrorHandler,
    TransTextbox,
    TransTextarea,
    TransMultiSelect2,
    NoAutocompleteTextfield,
    TransSelect2,
    SelfPaymentConditions,
  },
  props: [
    "memberGroups",
    "planIdentityId",
    "disabled",
    "selfPaymentSettings",
    "generalSettings",
  ],
  data() {
    return {
      floatActions: [
        {
          name: "addSelfPaymentSetting",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => this.addItem(),
          visible: () => !this.disabled,
        },
      ],
      error: null,
      provider: undefined,
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => this.editItem(item),
          visible: () => !this.disabled,
        },
        {
          name: "remove",
          icon: "delete",
          title: "globals.remove",
          handler: (item) => {
            const obj = this.provider.items.filter(
              (o) => o.Identifier === item.Identifier
            )[0];
            this.editedIndex = this.provider.items.indexOf(obj);
            this.editedItem = item;
            this.deleteDialog = true;
          },
          visible: () => !this.disabled,
        },
      ],
      editDialog: false,
      deleteDialog: false,
      valid: true,
      headers: SelfPaymentSettingsHeaders,
      editedIndex: -1,
      editedItem: null,
      validForm: false,
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
  },
  watch: {
    selfPaymentSettings: {
      handler(v) {
        if (this.provider) {
          console.log("&&&&&&&&----------------------------------------------------------------------------&&&&&&&&&&&&&&&&&&&&&&&&&", v);
          this.provider.items = v;
          this.$refs.table.getDataAsync();
        }
      },
    },
  },
  mounted() {
    this.loadPlanData();
  },
  methods: {
    async tryDelete() {
      this.provider.items.splice(this.editedIndex, 1);
      this.deleteDialog = false;
      this.$refs.table.getDataAsync();
      this.$emit("update-self-payment-settings", this.provider.items);
    },
    trans(item, field) {
      return translate2(item, field);
    },
    reload() {
      this.$refs.table.getDataAsync();
    },
    async loadPlanData() {
      try {
        console.log("@#@#@#@#@#@#@#@#@#@@@#--------------------------------------------------------------------------m", this.selfPaymentSettings)
        this.provider = new InMemoryProvider(
          this.selfPaymentSettings,
          this.headers
        );
      } catch (error) {
        this.error = error;
      }
    },
    validate() {
      if (this.$refs.form && this.$refs.form.validate()) {
        return true;
      }
      return false;
    },
    async editItem(item) {
      const obj = this.provider.items.filter(
        (o) => o.Identifier === item.Identifier
      )[0];
      this.editedIndex = this.provider.items.indexOf(obj);
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.editDialog = true;
    },
    async addItem() {
      const item = {
        SelfPaymentConditions: [],
        Identifier: Math.random().toString(),
      };
      this.editedIndex = -1;
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.editDialog = true;
    },
    close() {
      this.editDialog = false;
      this.editedItem = null;
      this.editedIndex = -1;
      this.$refs.form.resetValidation();
    },
    save() {
      this.editedItem.PlanId = this.planIdentityId;
      // this.editedItem.MembergroupIdentifier =
      //   this.editedItem.MemberGroup.Identifier;
      if (this.editedIndex > -1) {
        this.update();
      } else {
        this.add();
      }
    },
    async update() {
      this.provider.items[this.editedIndex] = JSON.parse(
        JSON.stringify(this.editedItem)
      );
      this.close();
      this.$refs.table.getDataAsync();
      this.$emit("update-self-payment-settings", this.provider.items);
    },
    async add() {
      this.provider.items.push(JSON.parse(JSON.stringify(this.editedItem)));
      console.log("$$$$$$$$$$$$$$$$$", this.editedItem)
      this.close();
      this.$refs.table.getDataAsync();
      this.$emit("update-self-payment-settings", this.provider.items);
    },
    updateSelfPaymentConditions(items) {
      console.log("-------------------------------", items);
      this.editedItem.SelfPaymentConditions = JSON.parse(JSON.stringify(items));
    },
  },
};
</script>
